import { io } from "socket.io-client";
const socket = io("https://ramukaknewbackend-a08t.onrender.com");
export default socket;
